export function removeExtraSpaces(input: string): string {
  return input.replace(/\s+/g, ' ').trim();
}

